import { render, staticRenderFns } from "./LabelLayoutSelect.vue?vue&type=template&id=09494763&scoped=true"
import script from "./LabelLayoutSelect.vue?vue&type=script&lang=ts"
export * from "./LabelLayoutSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09494763",
  null
  
)

export default component.exports